import React, { useEffect, useState } from 'react';
import { Badge, Popover } from '@mui/material'; 
import io from 'socket.io-client';
import NotificationList from './notificationList'; // Adjust the path if needed
import { Notifications as NotificationsIcon } from '@mui/icons-material';
// Connect to your Socket.IO server (adjust URL as needed)
const socket = io(process.env.REACT_APP_NOTIFICATION_SERVER_URI);

export default function NotificationBadge({ currentStaffImage, email }) {
  const [notifications, setNotifications] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    // Join the room using email for targeted notifications
    socket.emit('join', email);

    // Listen for notifications from the server
    socket.on('notification', (data) => {
       
      // Add a unique id for each notification (using Date.now() here)
      setNotifications((prev) => [
        ...prev,
        { id: Date.now(), message: data.message },
      ]);
    });

    // Cleanup listener on unmount
    return () => {
      socket.off('notification');
    };
  }, [email]);

  // Open the popover when the badge is clicked
  const handleIconClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Remove a single notification
  const removeNotification = (id) => {
    setNotifications((prev) => prev.filter((notif) => notif.id !== id));
  };

  // Clear all notifications
  const clearAll = () => {
    setNotifications([]);
  };

  const open = Boolean(anchorEl);

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <Badge
        badgeContent={notifications.length}
        color="error"
        onClick={handleIconClick}
        style={{ cursor: 'pointer' }}
      >
        <NotificationsIcon sx={{ fontSize: 24 }} />
      </Badge>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PaperProps={{
          style: { zIndex: 1300, padding: 8, minWidth: '250px' },
        }}
      >
        <NotificationList 
          notifications={notifications} 
          removeNotification={removeNotification}
          clearAll={clearAll}
        />
      </Popover>
    </div>
  );
}
